import React from 'react';
import _ from 'lodash';
import MultiChoiceOption from './multichoiceoption';
import Separator from './separator';
import TitleView from './titleview';
import SearchInput, {createFilter} from 'react-search-input';

class MultiChoice extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
      searchTerm: ''
		};

		this.onSelectOption = this.onSelectOption.bind(this);
		this.searchUpdated = this.searchUpdated.bind(this)
	}

	onSelectOption(option) {
		const question = this.props.question;
		const answer = this.props.answer;

		if (question.multi_answer) {
			if (_.includes(answer.multi_question_options_answer_ids, option.id)) {
				answer.multi_question_options_answer_ids = _.without(answer.multi_question_options_answer_ids, option.id);
			} else {
				answer.multi_question_options_answer_ids.push(option.id);
			}
		} else {
			answer.question_option_id = option.id;
		}

		this.props.onChangeAnswer(answer);
	}

	_renderOption(op) {
		const answer = this.props.answer;
		const question = this.props.question;

		let checked;
		if (question.multi_answer) {
			checked = _.includes(answer.multi_question_options_answer_ids, op.id);
		} else {
			checked = answer.question_option_id === op.id;
		}
		return <MultiChoiceOption option={op} key={op.id} onClick={this.onSelectOption.bind(this, op)} checked={checked}/>
	}

	searchUpdated (term) {
    this.setState({searchTerm: term})
  }

	render() {
		const question = this.props.question;

		const items = [];
		const separator = <Separator key={items.length}/>;
		items.push(separator);

		const filter = createFilter(this.state.searchTerm, ['option_text']);
		question.question_options.filter(filter).forEach((op) => {
			items.push(this._renderOption(op));
			const separator = <Separator key={items.length}/>;
			items.push(separator);
		});

		const searchInput = question.multi_answer ? null : <SearchInput className="search-input" onChange={this.searchUpdated} />;

		return (
			<div>
				<TitleView title={question.question_text}/>
				{searchInput}		
				{items}
			</div>
		);
	} 
}

export default MultiChoice;


// WEBPACK FOOTER //
// ./src/components/multichoice.jsx